import { Navigate, useLocation, useParams } from 'react-router-dom'

import { stripLanguagePrefix } from '@/lib/url-language-utils'

export function LegacyPlayRouteRedirectPage() {
  const { gameId } = useParams<{ gameId: string }>()
  const { pathname, search, hash } = useLocation()
  const params = new URLSearchParams(search)
  if (stripLanguagePrefix(pathname).startsWith('/replay/') && !params.has('view'))
    params.set('view', 'god')
  params.delete('layout')
  const query = params.toString()

  return (
    <Navigate
      to={`/play/${encodeURIComponent(gameId ?? '')}${query ? `?${query}` : ''}${hash}`}
      replace
    />
  )
}
